import AtendimentoVisualizar from './AtendimentoVisualizar';

export default AtendimentoVisualizar;